'use client';

import Button from 'components/gruenland/atoms/button/Button';
import Link from 'components/gruenland/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';

const NotFound = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="mt-[60px] flex flex-col items-center justify-center">
      <h1 className="text-[32px]">{formatMessage({ id: '404.title', defaultMessage: 'Pagina non trovata' })}</h1>
      <p className="mt-[10px]">
        {formatMessage({
          id: '404.text',
          defaultMessage: 'La pagina che stai cercando non esiste, probabilmente è stata spostata o eliminata.',
        })}
      </p>
      <Link link="/" className="mt-6">
        <Button variant="buttonPrimaryBlack">
          {formatMessage({ id: '404.cta', defaultMessage: 'Torna alla home' })}
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
